<template>
    <div>
        <v-text-field
                label="URL Youtube"
                v-model="search"
        ></v-text-field>
        <v-btn @click="download" :loading="isLoading">Télécharger</v-btn>
    </div>
</template>

<script>
import ky from 'ky';

export default {
  name: 'Youtube',
  data() {
    return {
      search: '',
      isLoading: false,
    };
  },
  methods: {
    async download() {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('https://www.googleapis.com/auth/drive');
      provider.addScope('https://www.googleapis.com/auth/youtube');

      let result;
      try {
        result = await firebase.auth().signInWithPopup(provider);
        // This gives you a Google Access Token. You can use it to access the Google API.
        const token = result.credential.accessToken;
        // The signed-in user info.
        const { user } = result;

        console.log('token', token);
        console.log('user', user);
        // ...
      } catch (error) {
        console.log('error', error);
      }

      this.isLoading = true;
      const response = await ky.get('https://yt2drive-ciicii.herokuapp.com/');
      if (response.status === 'OK') {
        this.isLoading = false;
        this.search = '';
      } else {
        alert('Erreur !');
        this.isLoading = false;
        this.search = '';
      }
    },
  },
};
</script>

<style scoped>

</style>
